import { gql as gql$1 } from "@apollo/client";
import { ApolloConsumer, ApolloError, ApolloProvider, InMemoryCache, NetworkStatus, defaultDataIdFromObject, makeVar, useApolloClient, useReactiveVar, useSubscription } from "@apollo/client";
export * from "graphql";
import { MockedProvider } from "@apollo/client/testing";
import * as generatedTypes from "./generated-types.js";
import { default as default2 } from "./apollo/apollo/client.js";
import { default as default3 } from "./apollo/testing/apollo/testing/debug-mocked-provider.js";
import { default as default4 } from "./hooks/hooks/use-lazy-query.js";
import { default as default5 } from "./hooks/hooks/use-mutation.js";
import { default as default6 } from "./hooks/hooks/use-query.js";
import { formatClientVersionInfo, getGraphQLErrorCode, wait } from "./apollo/apollo/utils.js";
const gql = gql$1;
export {
  ApolloConsumer,
  ApolloError,
  ApolloProvider,
  default3 as DebugMockedProvider,
  InMemoryCache,
  MockedProvider,
  NetworkStatus,
  generatedTypes as Types,
  defaultDataIdFromObject,
  formatClientVersionInfo,
  getGraphQLErrorCode,
  gql,
  default2 as initApolloClient,
  makeVar,
  useApolloClient,
  default4 as useLazyQuery,
  default5 as useMutation,
  default6 as useQuery,
  useReactiveVar,
  useSubscription,
  wait
};
//# sourceMappingURL=index.js.map
